var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-auto"},[_c('div',{staticClass:"mx-wd-100p",domProps:{"innerHTML":_vm._s(_vm.task.taskDesc)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }